import script from "./KnowledgeBaseForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./KnowledgeBaseForm.vue?vue&type=script&lang=ts&setup=true"

import "./KnowledgeBaseForm.vue?vue&type=style&index=0&id=df9f29ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df9f29ba"]])

export default __exports__